import { useQuery } from '@tanstack/react-query';
import { getCurrentFromClient } from '~/pages/api/external-training-modules';
import { useETMUnavailableError } from '~/pages/_shared/useETMUnavailableError';

const KEY = 'external-training-modules-search';

export function useExternalTrainingModules(query: string) {
   const RESULT_LIMIT = 10;

   const { handleServiceUnavailableWithToast } = useETMUnavailableError();

   return useQuery({
      queryKey: [KEY, query],
      queryFn: async () => {
         return await getCurrentFromClient({ query, limit: RESULT_LIMIT });
      },
      keepPreviousData: true,
      onError: handleServiceUnavailableWithToast,
   });
}
